import { Card, CardBody } from '@/components/ui/Card';
import { Input } from '@/components/ui/Input';
import { Toggle } from '@/components/ui/Toggle';
import { cn } from '@/lib/cn';
import { DIAS_DE_LA_SEMANA, type AgendaForm } from '@/lib/agenda-zoom';
import { LUGAR_DE_LA_HORA } from '@/lib/zona';

const titulo = 'text-sm font-semibold text-slate-900 dark:text-slate-100';
const ayuda = 'mt-0.5 text-xs text-slate-500 dark:text-slate-400';

/**
 * AGENDA DEL ZOOM en «Ajustes del agente» (tanda 3, ola C). Sin estado: lo prueba
 * renderToStaticMarkup. El enlace y las horas son del dueño: vacíos o de EJEMPLO
 * hasta que él los dé.
 */
export function AgendaDelZoomView({ form, errores, onChange }: { form: AgendaForm; errores: Record<string, string>; onChange: (f: AgendaForm) => void }) {
  const set = (patch: Partial<AgendaForm>) => onChange({ ...form, ...patch });
  const alternar = (n: number) => set({ dias: form.dias.includes(n) ? form.dias.filter((d) => d !== n) : [...form.dias, n] });
  return (
    <Card>
      <CardBody className="space-y-3 p-4">
        <div className="flex items-start justify-between gap-3">
          <div>
            <h2 className={titulo}>Agenda de la masterclass</h2>
            <p className={ayuda}>
              El agente ofrece las dos próximas fechas libres con su hora («mañana martes 7 de octubre a las 8:00 pm», hora
              de {LUGAR_DE_LA_HORA}) y aparta la que el cliente elige. Al cliente le recuerda la víspera a las 6:00 pm y 1
              hora antes, cuando le pide que confirme; a ti te avisa 2 horas y 15 minutos antes, y a los 30 minutos si no
              confirmó.
            </p>
          </div>
          <Toggle checked={form.activa} onChange={(activa) => set({ activa })} label="Agenda de la masterclass encendida" />
        </div>
        {form.activa && (
          <>
            <Input
              label="Enlace de tu sala de Zoom"
              placeholder="https://zoom.us/j/…"
              value={form.zoomUrl}
              error={errores.zoomUrl}
              onChange={(e) => set({ zoomUrl: e.target.value })}
            />
            <p className={ayuda}>Sin enlace, el agente no promete mandarlo y los recordatorios salen sin él; a ti te avisa que se lo mandes.</p>
            <div>
              <p className="mb-1 text-sm text-slate-700 dark:text-slate-200">Días con Zoom</p>
              <div className="flex flex-wrap gap-1.5">
                {DIAS_DE_LA_SEMANA.map((d) => (
                  <button
                    key={d.n}
                    type="button"
                    aria-pressed={form.dias.includes(d.n)}
                    onClick={() => alternar(d.n)}
                    className={cn(
                      'min-h-[36px] rounded-md px-3 text-sm',
                      form.dias.includes(d.n) ? 'bg-brand-600 text-white' : 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300',
                    )}
                  >
                    {d.corto}
                  </button>
                ))}
              </div>
              {errores.dias && <p className="mt-1 text-xs text-red-600">{errores.dias}</p>}
            </div>
            <div className="grid gap-3 sm:grid-cols-2">
              <Input
                label="Horas (24 h, separadas por comas)"
                placeholder="11:00, 16:00"
                value={form.horas}
                error={errores.horas}
                onChange={(e) => set({ horas: e.target.value })}
              />
              <Input
                label="Duración (minutos)"
                inputMode="numeric"
                value={form.duracionMin}
                error={errores.duracionMin}
                onChange={(e) => set({ duracionMin: e.target.value })}
              />
            </div>
          </>
        )}
      </CardBody>
    </Card>
  );
}
